import { HomeLoading } from "@/components/home-loading.tsx";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";

export default function EmbedLayout() {
  return (
    <Suspense fallback={<HomeLoading />}>
      <Outlet />
    </Suspense>
  );
}
